import React from 'react';
import loadScript from 'lib/loadScript';
import { marquee as MarqueePropType } from 'lib/CustomPropTypes';

const elementId = 'embed-marquee';

class Embed extends React.Component {
  static propTypes = {
    marquee: MarqueePropType.isRequired,
  };

  componentDidMount() {
    loadScript('https://nodeassets.nbcnews.com/cdnassets/pym/1.3.2/pym.min.js')
      .then(() => {
        let { marquee: { embed: { url } = {} } = {} } = this.props;

        if (window.pym && url) {
          // Strip Pym query string params from url that might have been copied.
          url = url.replace(/&(childId|parentUrl)=[^&]+/g, '');
          // Pym adds iframe and establishes communication for controlling height.
          //* Each iframe needs to be created with a new pym Parent, otherwise subsequent iframes
          //* will overwrite the prior ones
          this.pymChild = new window.pym.Parent(elementId, url);
        }
      });
  }

  render() {
    return (
      <div className="marquee marquee--embed">
        <div id={elementId} />
      </div>
    );
  }
}

export default Embed;
